import { render } from "./PrivacyView.vue?vue&type=template&id=06f9e6ed&scoped=true"
const script = {}

import "./PrivacyView.vue?vue&type=style&index=0&id=06f9e6ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f9e6ed"]])

export default __exports__